import { useState } from "react";

interface ModalModelType {
  /**
   * 鉴权弹窗
   */
  isAuthModalShown: boolean;
  /**
   * 全局弹窗是否展示完毕
   * 默认 false，即需要触发全局弹窗
   */
  isGlobalModalShown: boolean;
}

const initialState: ModalModelType = {
  isAuthModalShown: false,
  isGlobalModalShown: false,
};

const useModalModel = () => {
  const [state, setState] = useState(initialState);

  const resetModalModel = () => {
    setState(initialState);
  };

  return {
    ...state,
    setModalModel: setState,
    resetModalModel,
  };
};

export default useModalModel;
